<template>
  <div class="container-fluid">
    <!-- Add candidates -->
    <CandidatesForm formAction="add" :showAccordion="candidates.length === 0" />
    <!-- Candidates -->
    <Loading v-model:active="loading" loader="dots" />
    <div v-if="!loading">
      <CandidatesListV2
        :originalObjectsArray="candidates || []"
        :totalCount="totalCount"
        :currentPage="currentPage"
        :currentSearch="currentSearch"
        @page-change="handlePageChange"
        @search-change="handleSearchInput"
      />
    </div>
  </div>
</template>

<!-- Deploy Test -->

<script setup>
import CandidatesForm from '@/components/CandidatesForm.vue'
import CandidatesListV2 from '@/components/CandidatesListV2.vue'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import { storeToRefs } from 'pinia'
import { useAnalystTestsStore } from '@/stores/analystTests.store'
import { ref } from 'vue'
import debounce from 'lodash/debounce'

const { candidates, totalCount, loading } = storeToRefs(useAnalystTestsStore())
const { fetchCandidatesV2 } = useAnalystTestsStore()

const currentSearch = ref('')
const currentPage = ref(1)

const debouncedFetch = debounce((searchValue) => {
  currentPage.value = 1
  currentSearch.value = searchValue
  fetchCandidatesV2({
    page: currentPage.value,
    per_page: 4,
    search: currentSearch.value
  })
}, 1000) // 1000ms = 1 second delay

const handlePageChange = (page) => {
  currentPage.value = page
  fetchCandidatesV2({
    page,
    per_page: 4,
    search: currentSearch.value
  })
}
const handleSearchInput = (search) => {
  debouncedFetch(search)
}

fetchCandidatesV2({
  page: currentPage.value,
  per_page: 8,
  search: currentSearch.value
})
</script>
